/* The team's numbers page (sections/me-v-numbers.liquid). Reads GET /funnel from the mx-pack worker and draws:
   headline cards, the funnel (people per step, % who carried on from the step before) and a daily chart. */
(function () {
  var root = document.querySelector('[data-num]');
  if (!root || !root.getAttribute('data-token')) { return; }
  var endpoint = root.getAttribute('data-endpoint').replace(/\/$/, ''), token = root.getAttribute('data-token');
  var cardsEl = root.querySelector('[data-num-cards]'), funnelEl = root.querySelector('[data-num-funnel]'), chartEl = root.querySelector('[data-num-chart]');
  /* The main path, in order. The rest are shown as extras under it. */
  var PATH = ['home_view', 'start_click', 'signup_open', 'studio_view', 'upload', 'first_image', 'download', 'packs_shown', 'buy_click', 'purchase'];
  var EXTRA = ['try_drop', 'try_preview', 'low_balance'];

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) { n.className = cls; } if (text != null) { n.textContent = text; } return n; }
  function pct(a, b) { return b ? Math.round(a / b * 100) + '%' : '–'; }
  function money(v) { return '$' + v.toLocaleString('en-US'); }

  function draw(data) {
    var total = {}, label = {};
    data.steps.forEach(function (s) { total[s.e] = { people: 0, times: 0 }; label[s.e] = s.label; });
    var revenue = 0;
    data.days.forEach(function (d) {
      revenue += d.revenue;
      Object.keys(d.steps).forEach(function (e) { total[e].people += d.steps[e].people; total[e].times += d.steps[e].times; });
    });

    /* cards */
    cardsEl.innerHTML = '';
    var r = data.renders || { total: 0, cost: 0, watch: [] };
    [['Visitors', total.home_view.people], ['Started designing', total.studio_view.people], ['Made an image', total.first_image.people], ['Packs bought', total.purchase.times], ['Revenue', money(revenue)], ['Render cost', '$' + (r.cost || 0).toFixed(2)]]
      .forEach(function (c) { var d = el('div', 'mv-num__card'); d.appendChild(el('span', null, c[0])); d.appendChild(el('b', null, String(c[1]))); cardsEl.appendChild(d); });

    /* funnel */
    funnelEl.innerHTML = '';
    var top = Math.max(1, total[PATH[0]].people);
    PATH.forEach(function (e, i) {
      var n = e === 'purchase' ? total[e].times : total[e].people;
      var prev = i ? (PATH[i - 1] === 'purchase' ? total[PATH[i - 1]].times : total[PATH[i - 1]].people) : 0;
      var row = el('div', 'mv-num__row');
      row.appendChild(el('span', 'mv-num__label', label[e]));
      var bar = el('span', 'mv-num__bar'); var fill = el('i'); fill.style.width = Math.max(1.5, n / top * 100) + '%'; bar.appendChild(fill); row.appendChild(bar);
      row.appendChild(el('b', 'mv-num__n', String(n)));
      var conv = el('span', 'mv-num__conv', i ? pct(n, prev) : ''); if (i && prev && n / prev < 0.3) { conv.classList.add('is-low'); }
      row.appendChild(conv);
      funnelEl.appendChild(row);
    });
    /* Who is running up renders on the free side of the rules (free edits, the 20 free images after paying for a
       template, video previews). Nothing is blocked; it's here so Kaitlin can look (23 Sep). */
    var watchEl = root.querySelector('[data-num-watch]');
    if (watchEl) {
      watchEl.innerHTML = '';
      watchEl.appendChild(el('h2', 'mv-num__h2', 'Worth a look'));
      if (!r.watch || !r.watch.length) {
        watchEl.appendChild(el('p', 'mv-num__note', 'Nobody has gone over ' + (r.watchFrom || 40) + ' renders in a day. ' + r.total + ' renders in this period, ' + '$' + (r.cost || 0).toFixed(2) + ' in Dynamic Mockups credits.'));
      } else {
        r.watch.forEach(function (w) {
          var row = el('div', 'mv-num__row');
          row.appendChild(el('span', 'mv-num__label', 'Customer ' + w.cid));
          row.appendChild(el('b', 'mv-num__n', w.renders + ' renders'));
          row.appendChild(el('span', 'mv-num__conv', '$' + w.cost.toFixed(2) + ' · worst day ' + w.worst + ' on ' + w.worstDay));
          watchEl.appendChild(row);
        });
        watchEl.appendChild(el('p', 'mv-num__note', r.total + ' renders in this period, $' + (r.cost || 0).toFixed(2) + ' all up.'));
      }
    }
    var extras = el('div', 'mv-num__extras');
    EXTRA.forEach(function (e) { var x = el('span', null, label[e] + ': '); x.appendChild(el('b', null, String(total[e].people))); extras.appendChild(x); });
    funnelEl.appendChild(extras);

    /* daily chart: visitors, started, purchases */
    var W = 720, H = 180, pad = 24, days = data.days, max = 1;
    days.forEach(function (d) { max = Math.max(max, d.steps.home_view.people, d.steps.studio_view.people); });
    function line(key, cls, useTimes) {
      var pts = days.map(function (d, i) {
        var v = useTimes ? d.steps[key].times : d.steps[key].people;
        return (pad + i * (W - pad * 2) / Math.max(1, days.length - 1)).toFixed(1) + ',' + (H - pad - v / max * (H - pad * 2)).toFixed(1);
      });
      return '<polyline class="' + cls + '" points="' + pts.join(' ') + '" fill="none"/>';
    }
    chartEl.innerHTML = '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Visitors, people who started and packs bought, per day">' +
      line('home_view', 'is-a') + line('studio_view', 'is-b') + line('purchase', 'is-c', true) + '</svg>' +
      '<div class="mv-num__key"><span class="is-a">Visitors</span><span class="is-b">Started designing</span><span class="is-c">Packs bought</span><span class="mv-num__dates">' + days[0].day + ' to ' + days[days.length - 1].day + '</span></div>';
  }

  function load(days) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-days]'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-days') === String(days) ? 'true' : 'false'); });
    fetch(endpoint + '/funnel?days=' + days + '&token=' + encodeURIComponent(token))
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, b: b }; }); })
      .then(function (res) {
        if (!res.ok) { funnelEl.innerHTML = ''; funnelEl.appendChild(el('p', 'mv-num__note', res.b.error || 'Could not load the numbers.')); return; }
        draw(res.b);
      })
      .catch(function () { funnelEl.innerHTML = ''; funnelEl.appendChild(el('p', 'mv-num__note', 'Could not reach the numbers. Refresh to try again.')); });
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-days]'), function (b) { b.addEventListener('click', function () { load(Number(b.getAttribute('data-days'))); }); });
  load(30);
})();
